<template>
  <div v-if="visible" id="tab-mbl">
    <div class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <div>
          <el-dropdown
            no="1"
            :class="readonly?'not-click':''"
            split-button
            type="primary"
            @click="commandHandle(command1)"
            @command="p=>{command1=p;commandHandle(command1)}"
          >
            {{ command1 }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.CodeSearching')">{{ $t('SeaExport.CodeSearching') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromTheLastTime')">{{ $t('SeaExport.CopyFromTheLastTime') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromOtherBill')">{{ $t('SeaExport.CopyFromOtherBill') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromHbl')">{{ $t('SeaExport.CopyFromHbl') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            no="2"
            :disabled="feedBtnDisabled"
            type="primary"
            style="margin-right: 5px"
            @click="pm.completefeedClickHandler()"
          >{{ $t('SeaExport.CompleteTheDetails') }}</el-button>
          <el-dropdown
            no="3"
            :class="btnBLConfirmDisabled?'not-click':''"
            split-button
            type="primary"
            @click="commandHandle(command2)"
            @command="p=>{command2=p;commandHandle(command2)}"
          >
            {{ command2 }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.ReceiptHistory')">{{ $t('SeaExport.ReceiptHistory') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.BillingOfLadingRecordManager')">{{ $t('SeaExport.BillingOfLadingRecordManager') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            v-if="viewSource === 'SiBooking'"
            v-permission="['button_insurance_toInsure']"
            no="4"
            :disabled="isEdit"
            type="primary"
            @click="pm.toInsure()"
          >{{ $t('SeaExport.Insure') }}</el-button>
          <el-button
            v-show="btnMergeHblDataVisible"
            no="5"
            :disabled="readonly"
            type="primary"
            @click="pm.mergeHblData()"
          >{{ $t('SeaExport.mergeHblData') }}</el-button>
          <el-checkbox no="6" :value="form.state>=2" :disabled="true" style="margin-left: 10px;">{{ $t('SeaExport.Printed') }}</el-checkbox>
          <el-checkbox no="7" :value="form.state===3" :disabled="true" style="margin-left: -20px;">{{ $t('Message.Locked') }}</el-checkbox>
          <el-checkbox v-model="form.oversea" no="8" :disabled="readonly" style="margin-left: -20px;">{{ $t('SeaExport.BlBeReleased') }}</el-checkbox>
          <el-checkbox v-model="form.edi" no="9" :disabled="readonly" style="margin-left: -20px;" @change="pm.eDIChange($event)">{{ $t('SeaExport.BlEdi') }}</el-checkbox>
          <el-checkbox v-model="form.manifestEDI" no="10" :disabled="readonly" style="margin-left: -20px;">{{ $t('SeaExport.ManifestEdi') }}</el-checkbox>
          <el-checkbox v-model="form.printParam1" no="11" :disabled="readonly" style="margin-left: -20px;">Part of</el-checkbox>
          <el-checkbox v-model="form.printParam3" no="12" :disabled="readonly" style="margin-left: -20px;">{{ $t('SeaExport.ShowNumberOfPackagesGrossWeightAndMeasurementAfterCNTRNOSSEALNOS') }}</el-checkbox>
          <el-checkbox
            v-show="job.barge"
            v-model="form.printParam6"
            no="13"
            style="margin-left: -20px;"
            :disabled="readonly"
            @change="pm.printParam6Change()"
          >{{ $t('SeaExport.PrintBargeVesselAndVoyage') }}</el-checkbox>
          <el-checkbox v-model="form.showPODAgency" no="14" :disabled="readonly" style="margin-left: -20px;">Show POD Agency</el-checkbox>
          <el-button v-show="btnExcelVisible" no="15" type="primary" @click="pm.exportToExcel()">{{ $t('Payment.exportExcel') }}</el-button>
        </div>
      </div>
    </div>
    <div style="display: flex">
      <div class="down-first section form-column">
        <el-form :label-width="isZh ? '70px' : '75px'" label-position="right" style="height:100%">
          <span class="title">{{ $t('SeaExport.ConsigneeShipperAndNotifyInfo') }}</span>
          <el-form-item class="auto-width">
            <template slot="label"><span>{{ $t('Message.Shipper') }}</span><char-count :form="form" prefix="shipper" style="position:static;display:block;font-size:10px;color:#909399" /></template>
            <div style="display: flex;width: 100%">
              <el-input
                v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                v-model="form.shipperCode"
                :disabled="readonly"
                no="16"
              />
              <cargo-advance-select
                v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                no="17"
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{partnerManagementMode,branchId:$store.getters.currentOfficeId,shipper:true}"
                filterable
                :default-value="form.shipperId||''"
                @parentCallBack="p=>{senderAndReceiverChange('shipper',p, 7)}"
              />
              <el-button no="18" :disabled="readonly" type="primary" style="margin-left: 5px" @click="clearSenderAndReceiver('shipper',7)">{{ $t('SeaExport.Reset') }}</el-button>
            </div>
          </el-form-item>
          <el-form-item
            v-for="count in 7"
            :key="'shipperLine'+count"
            class="auto-width"
            :class="getSenderAndReceiverColor('shipperLine',count)"
          >
            <cargo-input
              :ref="'shipperLine'+count"
              v-model="form['shipperLine'+count]"
              :disabled="readonly"
              :no="'shipperLine'+count"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              :use-read-only="true"
              @dblclick.native="showSenderAndReceiverDialog('shipper',7,isCarrierUserMSC, notUppercaseShipperConsigneNotify)"
              @change="()=>wrapAddr(form,'shipperLine'+count,count+1 > 7 ? null :'shipperLine'+(count+1),maxChars)"
            />
          </el-form-item>
          <el-form-item class="auto-width">
            <template slot="label"><span>{{ $t('Message.Consignee') }}</span><char-count :form="form" prefix="consignee" style="position:static;display:block;font-size:10px;color:#909399" /></template>
            <div style="display: flex;width: 100%">
              <el-input
                v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                v-model="form.consigneeCode"
                :disabled="readonly"
                no="19"
              />
              <cargo-advance-select
                v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                no="20"
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{partnerManagementMode,branchId:$store.getters.currentOfficeId,consignee:true}"
                filterable
                :default-value="form.consigneeId||''"
                @parentCallBack="p=>{senderAndReceiverChange('consignee',p, 7)}"
              />
              <el-button type="primary" :disabled="readonly" style="margin-left: 5px" @click="clearSenderAndReceiver('consignee',7)">{{ $t('SeaExport.Reset') }}</el-button>
            </div>
          </el-form-item>
          <el-form-item
            v-for="count in 7"
            :key="'consigneeLine'+count"
            class="auto-width"
            :class="getSenderAndReceiverColor('consigneeLine',count)"
          >
            <cargo-input
              :ref="'consigneeLine'+count"
              v-model="form['consigneeLine'+count]"
              :disabled="readonly"
              :no="'consigneeLine'+count"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              :use-read-only="true"
              @dblclick.native="showSenderAndReceiverDialog('consignee',7,isCarrierUserMSC, notUppercaseShipperConsigneNotify)"
              @change="()=>wrapAddr(form,'consigneeLine'+count,count+1 > 7 ? null :'consigneeLine'+(count+1),maxChars)"
            />
          </el-form-item>
          <el-form-item class="auto-width">
            <template slot="label"><span>{{ $t('Message.Notify') }}</span><char-count :form="form" prefix="notify" style="position:static;display:block;font-size:10px;color:#909399" /></template>
            <div style="display: flex;">
              <el-input
                v-show="!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                v-model="form.notifyCode"
                :disabled="readonly"
                no="21"
                style="flex: 1;width: 120px"
              />
              <cargo-advance-select
                v-show="synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                no="22"
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{partnerManagementMode,branchId:$store.getters.currentOfficeId,notify:true}"
                filterable
                :default-value="form.notifyId||''"
                style="flex: 1;width: 120px"
                @parentCallBack="p=>{senderAndReceiverChange('notify',p, 7)}"
              />
              <el-button no="23" :disabled="readonly" type="primary" style="margin-left: 5px" @click="clearSenderAndReceiver('notify',7)">{{ $t('SeaExport.Reset') }}</el-button>
              <el-button no="24" :disabled="readonly" type="primary" style="margin-left: 5px" @click="pm.onCopyConsignee()">{{ $t('SeaExport.CopyTheConsignee') }}</el-button>
            </div>
          </el-form-item>
          <el-form-item
            v-for="count in 7"
            :key="'notifyLine'+count"
            class="auto-width"
            :class="getSenderAndReceiverColor('notifyLine',count)"
          >
            <cargo-input
              :ref="'notifyLine'+count"
              v-model="form['notifyLine'+count]"
              :disabled="readonly"
              :no="'notifyLine'+count"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              :use-read-only="true"
              @dblclick.native="showSenderAndReceiverDialog('notify',7,isCarrierUserMSC, notUppercaseShipperConsigneNotify)"
              @change="()=>wrapAddr(form,'notifyLine'+count,count+1 > 7 ? null :'notifyLine'+(count+1),maxChars)"
            />
          </el-form-item>
          <el-form-item>
            <div style="display: flex;">
              <el-select
                v-model="otherField"
                :disabled="readonly"
                no="25"
                style="width: 130px;"
                @change="val=>{pm.otherInfoChangeHandler(val)}"
              >
                <el-option
                  v-for="(item,index) in otherFieldsData"
                  :key="index"
                  :label="item.englishName"
                  :value="item.code"
                />
              </el-select>
              <cargo-input
                v-if="otherField!=='ALSO NOTIFY'"
                v-model="otherCode"
                no="26"
                :disabled="readonly"
                :maxlength="maxChars"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                style="margin-left: 5px;width: 170px;"
              />
              <cargo-advance-select
                v-if="otherField==='ALSO NOTIFY'"
                no="79"
                :disabled="readonly"
                :allow-create="true"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{ notify: true, active: true }"
                tag-name="englishName"
                tag-value="englishName"
                filterable
                style="flex: 1;margin-left: 5px;"
                :default-value="otherCode||''"
                @parentCallBack="p=>{pm.alsoNotifyAutoCompleteChange(p)}"
              />
            </div>
          </el-form-item>
          <div v-show="otherField==='ALSO NOTIFY'">
            <cargo-rich-textarea
              v-model="form.alsoNotify"
              no="27"
              :disabled="!isEdit"
              :text-chars="maxChars"
              :warning-count="warningCount"
              style="height: 110px; margin-left: 70px"
              @dblclick.native="showAdvanceTextDialog('ALSO NOTIFY',form.alsoNotify,val=>{form.alsoNotify=val},false,null,notUppercaseShipperConsigneNotify, {
                warningCount: 45,
                maxChar: 0
              })"
            />
          </div>
          <div v-show="otherField==='DGCONSIGN'">
            <el-form-item
              v-for="count in 7"
              :key="'dgconsignLine'+count"
              class="auto-width"
            >
              <cargo-input
                :ref="'dgconsignLine'+count"
                v-model="form['dgconsignLine'+count]"
                :disabled="readonly"
                :no="'dgconsignLine'+count"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :use-read-only="true"
                @dblclick.native="showSenderAndReceiverDialog('dgconsign',7, isCarrierUserMSC, notUppercaseShipperConsigneNotify)"
                @change="()=>wrapAddr(form,'dgconsignLine'+count,count+1 > 7 ? null :'dgconsignLine'+(count+1),maxChars)"
              />
            </el-form-item>
          </div>
          <div v-show="otherField==='ELSEINVOICE'">
            <el-form-item
              v-for="count in 7"
              :key="'elseInvoiceLine'+count"
              class="auto-width"
            >
              <cargo-input
                :ref="'elseInvoiceLine'+count"
                v-model="form['elseInvoiceLine'+count]"
                :disabled="readonly"
                :no="'elseInvoiceLine'+count"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :use-read-only="true"
                @dblclick.native="showSenderAndReceiverDialog('elseInvoice',7, true, notUppercaseShipperConsigneNotify)"
                @change="()=>wrapAddr(form,'elseInvoiceLine'+count,count+1 > 7 ? null :'elseInvoiceLine'+(count+1),maxChars)"
              />
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="down-two section form-column">
        <el-form :disabled="readonly" :label-width="isZh ? '85px' : '160px'" label-position="right" style="height:100%">
          <span class="title">{{ $t('SeaExport.CargoInfo') }}</span>
          <el-form-item :label="$t('SeaExport.NumberOfPackagesOnBl')">
            <auto-number-input
              v-model="form.quantity"
              no="28"
              :precision="0"
              :min="0"
              :disabled="isCrossTenantSEToSI"
              @change="pm.quantityChange()"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Package')" :class="variableCss.packing">
            <!-- <cargo-advance-select
              :select-type="selectTypeNames.basic_data_Packing"
              filterable
              :default-value="form.packing"
              style="width:100%;"
              @parentCallBack="p=>{pm.packingChange(p)}"
            /> -->
            <cargo-packing-select
              no="29"
              :disabled="isCrossTenantSEToSI"
              :default-value="form.packing"
              @change="p => {pm.packingChange(p)}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Pieces2')" :class="variableCss.insideQuantity">
            <auto-number-input
              v-model="form.insideQuantity"
              no="30"
              :precision="0"
              :min="0"
              :disabled="isCrossTenantSEToSI"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PiecesType2')" :class="variableCss.insidePacking">
            <!-- <cargo-advance-select
              :select-type="selectTypeNames.basic_data_Packing"
              filterable
              :default-value="form.insidePacking"
              style="width:100%;"
              @parentCallBack="p=>{form.insidePacking=p.value}"
            /> -->
            <cargo-packing-select
              no="31"
              :default-value="form.insidePacking"
              :disabled="isCrossTenantSEToSI"
              @change="p => {form.insidePacking=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.GrossWeight')" :class="'custom '+variableCss.weight">
            <div class="form-item-input" :class="readonly ? 'input-disabled': ''">
              <auto-number-input
                v-model="form.weight"
                no="32"
                :precision="3"
                :min="0"
                :disabled="isCrossTenantSEToSI"
                @change="pm.weightChange()"
              />
              <span>KGS</span>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Cubage')" :class="'custom '+variableCss.cubage">
            <div class="form-item-input" :class="readonly ? 'input-disabled': ''">
              <auto-number-input
                v-model="form.cubage"
                no="33"
                :precision="3"
                :min="0"
                :disabled="isCrossTenantSEToSI"
                @change="pm.cubageChange()"
              />
              <span>CBM</span>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ChargedWeightRT')" class="custom">
            <div class="form-item-input" :class="readonly ? 'input-disabled': ''">
              <auto-number-input
                v-model="form.chargeWeight"
                no="34"
                :precision="3"
                :min="0"
                :disabled="isCrossTenantSEToSI"
                @change="pm.txtChargeWeightHandler()"
              />
              <span>M/T</span>
            </div>
          </el-form-item>
          <el-form-item class="custom">
            <el-button
              no="35"
              type="primary"
              style="float:right;margin-left:5px"
              @click="pm.getHBLInfo('EName')"
            >{{ $t('SeaExport.CopyEnglishDescriptionOfGoodsFromHBL') }}</el-button>
            <el-button
              v-show="masterFlag"
              no="36"
              type="primary"
              style="float:right"
              @click="pm.getSlavesHBLEnglishName()"
            >{{ $t('SeaExport.CopyEnglishDescriptionOfGoodsFromReceipt') }}</el-button>
          </el-form-item>
          <el-form-item :label="$t('queryJob.englishDescriptionOfGoods')" :class="'label-none custom '+variableCss.cargoEnglishName">
            <cargo-rich-textarea
              v-model="form.cargoEnglishName"
              no="37"
              :show-count="true"
              :text-chars="englishNameMaxChars"
              :warning-count="englishNameWarningCount"
              :auto-uppercase="isUppercaseByConfig"
              style="height: 110px;"
              :disabled="!isEdit || textareaDisabled || isCrossTenantSEToSI"
              @change="pm.txtCargoEnglishNameChangeHandler()"
              @dblclick.native="showAdvanceTextDialog($t('queryJob.englishDescriptionOfGoods'),form.cargoEnglishName,val=>{form.cargoEnglishName=val},false,null,isUppercaseByConfig , {
                warningCount: englishNameWarningCount,
                maxChar: englishNameMaxChars
              })"
            />
          </el-form-item>
          <el-form-item class="custom">
            <el-button
              no="38"
              type="primary"
              style="float:right;margin-left:5px"
              @click="pm.getHBLInfo('mark')"
            >{{ $t('SeaExport.CopyMarksFromHbl') }}</el-button>
            <el-button
              v-show="masterFlag"
              type="primary"
              style="float:right"
              @click="pm.getSlavesHBLMark()"
            >{{ $t('SeaExport.CopyMarksFromReceipt') }}</el-button>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Marks')" :class="'label-none custom '+variableCss.mark">
            <cargo-rich-textarea
              v-model="form.mark"
              no="39"
              :show-count="true"
              :text-chars="markMaxChars"
              :warning-count="markWarningCount"
              style="height: 110px;"
              :disabled="!isEdit || textareaDisabled || isCrossTenantSEToSI"
              :auto-uppercase="isUppercaseByConfig"
              @change="pm.txtMarkChangeHandler($event)"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),form.mark,val=>{form.mark=val},false,null,isUppercaseByConfig , {
                warningCount: markWarningCount,
                maxChar: markMaxChars
              })"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CapitalizedNumbersOfPackages')" class="label-none custom">
            <el-input v-model="form.quantitySum" no="40" :disabled="true" />
          </el-form-item>
        </el-form>
      </div>
      <div class="down-three section form-column">
        <el-form :disabled="readonly" :label-width="isZh ? '96px' : '110px'" label-position="right" style="height:100%">
          <span class="title">{{ $t('SeaExport.TransportInfo') }}</span>
          <el-form-item label="MB/L NO.">
            <div style="display: flex">
              <div style="width: 80%;">
                <el-input v-model="job.mbl" no="41" :disabled="isCrossTenantSEToSI" />
              </div>
            </div>
          </el-form-item>
          <el-form-item label="SO NO.">
            <el-input no="42" :disabled="true" :value="job.soNo" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.MBLBillOfLadingNum')">
            <el-input v-model="form.serialNo" no="43" />
          </el-form-item>
          <el-form-item :label="$t('Payment.vesselAndVoyage')">
            <el-input no="44" :disabled="true" :value="txtFirstVesselVoyage" />
          </el-form-item>
          <el-form-item :label="$t('queryJob.dateOfDeparture')">
            <el-input no="45" :value="job.etd ? moment(job.etd).format('YYYY-MM-DD') : null" :disabled="true" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DocDispatchingPlace')" :class="variableCss.dispatchingPlace">
            <el-input v-model="form.dispatchingPlace" no="46" :disabled="isCrossTenantSEToSI" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PortOfLoadingOnBl')" :class="variableCss.loadingPort">
            <el-input v-model="form.loadingPort" no="47" :disabled="isCrossTenantSEToSI" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PortOfDischargeOnBl')" :class="variableCss.dischargingPort">
            <el-input v-model="form.dischargingPort" no="48" :disabled="isCrossTenantSEToSI" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PlaceOfDeliveryOnBl')" :class="variableCss.destinationPort">
            <el-input v-model="form.destinationPort" no="49" :disabled="isCrossTenantSEToSI" />
          </el-form-item>
          <!--            <el-form-item label="提单最终目的地">-->
          <!--              <el-input v-model="form.destinationPlace" />-->
          <!--            </el-form-item>-->
          <el-form-item :label="$t('SeaExport.MethodOfMblPayment')">
            <el-input
              no="50"
              :value="ColumnUtils.paymentTermLabelFunc(job.paymentTermMBL)"
              :disabled="isCrossTenantSEToSI"
              @input="val=>{job.paymentTermMBL=val}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PlaceOfMblPayment2')">
            <el-input no="51" :disabled="true" :value="form.paymentPlaceBL" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.TransportationClause')">
            <el-input no="52" :disabled="true" :value="job.freightTermMBL" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.NoOfOriginalBls')" :class="variableCss.blNumber">
            <el-input v-model="form.blNumber" no="53" :disabled="isCrossTenantSEToSI" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PlaceOfIssue')">
            <el-input v-model="form.signPlaceBL" no="54" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DateOfIssue')">
            <el-date-picker v-model="form.signDateBL" no="55" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.BlRemarks')" :class="variableCss.remarks">
            <cargo-rich-textarea
              v-model="form.remarks"
              no="56"
              style="height: 110px;"
              :text-chars="0"
              :warning-count="-1"
              :disabled="readonly"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.BlRemarks'),form.remarks,val=>{form.remarks=val}, false, null, false, {
                warningCount: -1,
                maxChar: 0,
                autoUppercase: false,
                autoHalfWord: false
              })"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="down-four section form-column">
        <el-form :disabled="readonly" :label-width="isZh ? '100px' : '160px'" label-position="right" style="height:100%">
          <span class="title">{{ $t('SeaExport.OtherInfo') }}</span>
          <el-form-item :label="$t('SeaExport.BlType')">
            <el-select
              v-model="form.releaseType"
              no="57"
              :disabled="isCrossTenantSEToSI"
              @change="val=>{pm.cmbreleaseTypeMBLChangeHandler(val)}"
            >
              <el-option
                v-for="(item,index) in blModeList"
                :key="index"
                :label="item.name"
                :value="item.serialNumber||''"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.BlProperty')">
            <el-select
              no="58"
              :value="job.typeMBL||1"
              :disabled="cmbtypeMBLDisabled || isCrossTenantSEToSI"
              @change="val=>{typeMblHandle(val)}"
            >
              <el-option
                v-for="(item,index) in BILL_TYPES"
                :key="index"
                :label="isZh?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-show="job.jointMasterMBLUuid" :label="$t('SeaExport.MBLHBR')">
            <el-input no="59" :value="job.jointMasterMBL?job.jointMasterMBL.jobNo:''" />
          </el-form-item>
          <!--            CARGO-40147 放单管理，不允许多次取回            -->
          <!--          <el-form-item label="" class="red">-->
          <!--            <cargo-button-container-->
          <!--              v-permission="['button_SingleRelease_singleRelease']"-->
          <!--              no="60"-->
          <!--              :disabled="btnReleasingDisabled"-->
          <!--              style="float:right;margin-left:5px"-->
          <!--              @click="pm.btnReleasingClickHandler()"-->
          <!--            >-->
          <!--              <el-button-->
          <!--                type="primary"-->
          <!--              >{{-->
          <!--                form.cfmState === 10 ? $t('SeaExport.CancelReleasing') : $t('SeaExport.Releasing')-->
          <!--              }}</el-button>-->
          <!--            </cargo-button-container>-->
          <!--            <cargo-button-container-->
          <!--              v-permission="['button_SingleRelease_getBack']"-->
          <!--              no="61"-->
          <!--              :disabled="btnGetBackDisabled"-->
          <!--              style="float:right"-->
          <!--              @click="pm.btnGetBackClickHandler()"-->
          <!--            >-->
          <!--              <el-button-->
          <!--                type="primary"-->
          <!--              >{{-->
          <!--                form.bliStatus === 7 ? $t('SeaExport.CancelGetBack') : $t('SeaExport.Back')-->
          <!--              }}</el-button>-->
          <!--            </cargo-button-container>-->
          <!--          </el-form-item>-->
          <el-form-item :label="$t('SeaExport.ReleasingStatus')" class="red">
            <el-input no="62" :disabled="true" :value="lblReleaseState" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.preverifyDate')">
            <el-date-picker
              v-model="form.reviewDate"
              no="63"
              :disabled="true"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DateOfCargoDetention')">
            <el-date-picker
              v-model="form.withholdDate"
              no="64"
              :disabled="true"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.BlReleasingNo')">
            <el-input no="65" :disabled="true" :value="form.surrenderedNo" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ReleasingDate')">
            <el-date-picker
              v-model="form.releaseDate"
              no="66"
              :disabled="true"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ParamRemark')">
            <el-select v-model="form.printParam4" no="67">
              <el-option
                v-for="(item,index) in pm.printParam4Type"
                :key="index"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ShippingCompanySCAC')">
            <el-input no="68" :disabled="true" :value="job.carrierScac || txtCarrierScAc" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.OverseasAgentSCAC')">
            <el-input no="69" :disabled="true" :value="txtBookingAgentScAc" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ManifestDescriptionOfGoods')">
            <cargo-rich-textarea
              v-model="form.cargoManifestName"
              no="70"
              style="height: 110px;"
              :disabled="!isEdit"
              :text-chars="0"
              :warning-count="-1"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.ManifestDescriptionOfGoods'),form.cargoManifestName,val=>{form.cargoManifestName=val},false, null, false, {
                warningCount: -1,
                maxChar: 0,
                autoUppercase: false,
                autoHalfWord: false
              })"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ReasonOfCargoDetention')">
            <el-input no="71" :disabled="true" :value="form.withholdReason" type="textarea" :rows="5" />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        v-model="advanceTextDialog.value"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :auto-uppercase="advanceTextDialog.isUppercase"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :disabled="!isEdit"
        style="height: 320px;"
      />
      <el-form
        v-show="advanceTextDialog.showContact"
        :inline="true"
        :disabled="!isEdit"
        label-width="50px"
        label-position="left"
        style="padding-top:5px"
      >
        <el-form-item :label="$t('Payment.contactPerson')" class="custom">
          <el-input v-model="advanceTextDialog.extendData.contact" no="72" style="width:110px" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Tel')" class="custom">
          <el-input v-model="advanceTextDialog.extendData.mobile" no="73" style="width:110px" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Fax')" class="custom">
          <el-input v-model="advanceTextDialog.extendData.fax" no="74" style="width:110px" />
        </el-form-item>
      </el-form>
      <el-form
        v-show="advanceTextDialog.showContact"
        :inline="true"
        :disabled="!isEdit"
        label-width="50px"
        label-position="left"
      >
        <el-form-item :label="$t('SeaExport.Email2')" class="custom">
          <el-input v-model="advanceTextDialog.extendData.email" no="75" style="width:110px" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ZIP')" class="custom">
          <el-input v-model="advanceTextDialog.extendData.zipCode" no="76" style="width:110px" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.City')" class="custom">
          <cargo-location-select
            :default-value="advanceTextDialog.extendData.city"
            style="width:110px;"
            @change="p=>{advanceTextDialog.extendData.city=p.value}"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button v-show="isEdit" no="77" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="78"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog :visible.sync="billAddressDialog.visible" :job="billAddressDialog.job" :params="billAddressDialog.params" @callback="codeSearchCallback" />
    <!-- 工作单检索弹窗 -->
    <search-bill-no-dialog
      :visible.sync="searchBillNoDialog.visible"
      :params="searchBillNoDialog.params"
      :lob="job.lob"
      @selected="p=>{pm.selectionItemHandler(p)}"
    />

    <!-- 回执历史弹窗 -->
    <receipt-history-dialog :visible.sync="receiptHistoryDialog.visible" :job-uuid="job.uuid||''" />
    <!-- 提单日志弹窗 -->
    <status-change-history-dialog
      :visible.sync="statusChangeHistoryDialog.visible"
      :business-data-id="form.uuid"
    />
  </div>
</template>

<script>
import { TabMBLPM } from './tabMBLPM'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import billAddressDialog from '@/components/Cargo/Job/billAddressDialog'
import searchBillNoDialog from '@/views/cargo/v0/SeaExport/components/edi/searchBillNoDialog'
import emailInput from '@/components/Cargo/Job/emailInput'
import receiptHistoryDialog from '@/components/Cargo/Job/receiptHistoryDialog'
import statusChangeHistoryDialog from '@/components/Cargo/Job/statusChangeHistoryDialog'
import cargoLocationSelect from '@/components/Cargo/Common/cargoLocationSelect'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import moment from 'moment'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { BILL_TYPES } from '@/class/cargo/model/parameters/BillType'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { SeaImCargoDoc } from '@/class/model/booking/SeaImCargoDoc'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import SenderAndReceiver from '@/mixin/SenderAndReceiver'
import * as CargoDocCfmState from '@/class/cargo/model/parameters/CargoDocCfmState'
import CargoButtonContainer from '@/components/Cargo/Common/cargoButtonContainer'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'
import { getToken } from '@/utils/auth'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { PrintTemplateUtil } from '@/class/cargo/model/utils/PrintTemplateUtil'

export default {
  name: 'TabMbl',
  components: {
    CargoButtonContainer, cargoPackingSelect, AutoNumberInput,
    cargoAdvanceSelect, cargoInput, billAddressDialog, searchBillNoDialog, emailInput, cargoRichTextarea,
    receiptHistoryDialog, statusChangeHistoryDialog, cargoLocationSelect
  },
  mixins: [SenderAndReceiver],
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    isCrossTenantSEToSI: { // 是否跨租户出口转进口
      type: Boolean,
      required: false
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    },
    viewSource: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      ColumnUtils,
      isZh: this.$store.getters.language === 'zh',
      maxChars: 0,
      warningCount: -1,
      englishNameMaxChars: 0,
      markMaxChars: 0,
      englishNameWarningCount: -1,
      markWarningCount: -1,
      textareaDisabled: false, // 英文名称、唛头文本框只读控制
      visible: false, // 先隐藏，避免组件在初始化完成前，做一些无效的处理（频繁刷新组件、调用接口等）
      pm: new TabMBLPM(this),
      addrPM: null, // 提单地址
      isCarrierUserMSC: false,
      moment,
      BILL_TYPES,
      CargoDocUtil,
      selectTypeNames: TYPE_NAMES,
      partnerManagementMode: 0,
      mergeHblData: false,
      cmbtypeMBLDisabled: false,
      isUppercase: true,
      masterFlag: false,
      blModeList: [
        { serialNumber: 1, code: 'ORIGINAL', name: 'ORIGINAL', localName: '正本' },
        { serialNumber: 2, code: 'SURRENDERED', name: 'SURRENDERED', localName: '电放' },
        { serialNumber: 3, code: 'SEA WAYBILL', name: 'SEA WAYBILL', localName: '电放' }
      ],
      otherFieldsData: [],
      job: {},
      consoleURL: '',
      form: new SeaImCargoDoc().fillDefaultValue().getData(),
      otherField: 'alsoNotify',
      otherCode: '',
      lblReleaseState: '',
      txtCarrierScAc: '',
      txtBookingAgentScAc: '',
      txtFirstVesselVoyage: '',
      command1: this.$t('SeaExport.CodeSearching'),
      command2: this.$t('SeaExport.ReceiptHistory'),
      billAddressDialog: {
        visible: false,
        params: null,
        job: null
      },
      searchBillNoDialog: {
        visible: false,
        params: {}
      },
      emailInput: {
        visible: false,
        emailTitle: '',
        emailContent: '',
        fileIdList: ''
      },
      receiptHistoryDialog: {
        visible: false
      },
      statusChangeHistoryDialog: {
        visible: false
      },
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      isUppercaseByConfig: true // CARGO-49117 是否大写
    }
  },
  computed: {
    readonly() {
      return !this.isEdit
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look' && !this.job.printHblZbLock && (!this.form.uuid || this.form.state < 2)
    },
    feedBtnDisabled() {
      return this.isEdit || !this.form.uuid || this.form.cfmState === 5
    },
    btnBLConfirmDisabled() {
      return this.isEdit || !this.form.uuid
    },
    btnMergeHblDataVisible() {
      return this.mergeHblData && this.job && this.job.typeHBL === 2
    },
    btnExcelVisible() {
      if (this.context.office.code === 'NB' && this.job.carrierId) {
        const cpy = this.context.companyList.find(p => p.cmpIdx === this.job.carrierId)
        return cpy && (cpy.shortName === 'ZIM' || cpy.shortName === 'CSAV')
      }
      return false
    },
    btnGetBackDisabled() {
      return !(!this.isEdit && this.form && this.form.cfmState !== CargoDocCfmState.CARGODOC_CFM_STATE_RELEASED.code)
    },
    btnReleasingDisabled() {
      return !(!this.isEdit && this.form)
    },
    user() {
      return this.context.user
    },
    config() {
      return this.context.config
    }
  },
  async created() {
    this.notUppercaseShipperConsigneNotify = await JobUtils.uppercaseShipperConsigneNotify(this.context.config)
    this.isUppercaseByConfig = Number(this.context.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
    await this.refreshNonResponsiveData()
  },
  methods: {
    async refreshNonResponsiveData() { // 刷新配置等本组件依赖但并非双向绑定的数据
      this.context.loading = true
      const loading = getLoading()
      await this.context.prepareData()
      this.partnerManagementMode = Number(this.config.get('PartnerManagementMode')) // 是否启用合作伙伴管理模式
      this.mergeHblData = Number(this.config.get('mergeHblData')) === 1
      this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode = Number(this.config.get('synchronousShipperCodeAndConsigneeCodeAndNotifyCode')) === 1
      this.pm.init()
      this.visible = true
      this.context.loading = false
      loading.close()
    },
    async onShow(row, isRefresh) {
      // 当勾选mbl时执行
      if (row.signMBL && this.action === 'edit') {
        await this.pm.initPortCode()
      }
      this.pm.showScac()
      if (!isRefresh) {
        await this.pm.editingChanged()
        this.pm.refreshVessel()
        return
      }
      await this.refreshNonResponsiveData()
      this.masterFlag = row.masterFlag || false
      this.job = row
      await this.pm.changeJob()
      await this.pm.fillView()
      if (row.signMBL && this.action === 'copy') {
        this.form.loadingPort = await this.pm.getPortCodeEnglishName(row.loadingPortCode)
        this.form.dischargingPort = await this.pm.getPortCodeEnglishName(row.dischargingPortCode)
      }
    },
    getSubmitData() {
      this.pm.fillModel()
      const job = { ...this.job }
      return {
        job,
        seaCargoDoc: this.job.seaCargoDoc
      }
    },
    async executeTask() {
      await this.pm.executeTask()
    },
    commandHandle(command) {
      switch (command) {
        case this.$t('SeaExport.CodeSearching'):
          this.billAddressDialog.visible = true
          this.billAddressDialog.params = this.form
          this.billAddressDialog.job = this.job
          break
        case this.$t('SeaExport.CopyFromTheLastTime'):
          this.pm.onCopy1()
          break
        case this.$t('SeaExport.CopyFromOtherBill'):
          this.searchBillNoDialog.params = this.form
          this.searchBillNoDialog.visible = true
          break
        case this.$t('SeaExport.CopyFromHbl'):
          this.pm.onCopyHBL()
          break
        case this.$t('SeaExport.ReceiptHistory'):
          this.receiptHistoryDialog.visible = true
          break
        case this.$t('SeaExport.BillingOfLadingRecordManager'):
          this.statusChangeHistoryDialog.visible = true
          break
      }
    },
    codeSearchCallback(data) {
      console.log(data)
      if (data.shipperInfo) {
        this.splitSenderAndReceiverLine('shipper', 7, data.shipperInfo)
      }
      if (data.consigneeInfo) {
        this.splitSenderAndReceiverLine('consignee', 7, data.consigneeInfo)
      }
      if (data.notifyInfo) {
        this.splitSenderAndReceiverLine('notify', 7, data.notifyInfo)
      }
      if (data.hasOwnProperty('shipperCode')) {
        this.form['shipperCode'] = data.shipperCode || ''
      }
      if (data.hasOwnProperty('consigneeCode')) {
        this.form['consigneeCode'] = data.consigneeCode || ''
      }
      if (data.hasOwnProperty('notifyCode')) {
        this.form['notifyCode'] = data.notifyCode || ''
      }
    },
    splitShipperLine(val, extendData) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['shipperLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['shipperLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['shipperLine' + i] = ''
      }
      if (extendData) {
        this.form.shipperContact = extendData.contact
        this.form.shipperMobile = extendData.mobile
        this.form.shipperFax = extendData.fax
        this.form.shipperEmail = extendData.email
        this.form.shipperZipCode = extendData.zipCode
        this.form.shipperCity = extendData.city
      }
    },
    splitConsigneeLine(val, extendData) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['consigneeLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['consigneeLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['consigneeLine' + i] = ''
      }
      if (extendData) {
        this.form.consigneeContact = extendData.contact
        this.form.consigneeMobile = extendData.mobile
        this.form.consigneeFax = extendData.fax
        this.form.consigneeEmail = extendData.email
        this.form.consigneeZipCode = extendData.zipCode
        this.form.consigneeCity = extendData.city
      }
    },
    splitNotifyLine(val, extendData) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['notifyLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['notifyLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['notifyLine' + i] = ''
      }
      if (extendData) {
        this.form.notifyContact = extendData.contact
        this.form.notifyMobile = extendData.mobile
        this.form.notifyFax = extendData.fax
        this.form.notifyEmail = extendData.email
        this.form.notifyZipCode = extendData.zipCode
        this.form.notifyCity = extendData.city
      }
    },
    // 组装打印参数
    getPrintData() {
      const params = {}
      if (this.form) {
        // params.cargoDocUuid = this.form.uuid
        // params.DOC_UUID = this.form.uuid
        PrintTemplateUtil.buildPrintDataBySimbl(this.form, params)
        params.category = 'SIMBL'
        params.ctx = new SeaImportJob(this.job)
      }
      return params
    },
    typeMblHandle(value) {
      this.pm.cmbtypeMBLChangeHandler(value)
      if (this.job.typeMBL === 0 || this.job.typeMBL === 1) {
        this.$emit('tabNotCheckedCallBack', 'tabMBL2')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-column{
  .form-item-input{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    background-color: #fff;
    border: 1px solid #E4E7ED;
    span{
      width: 40px;
      height: 28px;
      line-height: 26px;
      box-sizing: border-box;
      padding-left: 5px;
      padding-top: 1px;
    }
    /deep/.el-input {
      width: 86%;
      input{
        border: 0;
        padding-right: 0 !important;
        text-align: right;
      }
    }
  }
  .input-disabled{
    background-color: #f0f3f8 !important;
    cursor: not-allowed;
  }
}
</style>

<!-- 英文样式 -->
<style scoped lang="scss">
#app.en {
  .section::v-deep {
    &.down-first {
      min-width: 322px;
    }
    &.down-two {
      min-width: 398px;
    }
    &.down-three {
      min-width: 334px;
    }
    &.down-four {
      min-width: 400px;
    }
  }
}
</style>
